if ($('body.id--11').length) {
    $('#content').append($('#search-group-articles').clone());

    getUsps("#content");
    $('.breadcrumbs-wrapper').append($('#content h2').clone());



    var categoryCount = $("#search-group-categories .search-results-group-list ul > li").length;
    $("#search-group-categories h4").text('Kategorie produktů (' + categoryCount + ')');
    $("#search-group-categories a.display-results-group").text('Zobrazit všechny kategorie (' + categoryCount + ')');

    $('#search-group-categories .search-results-group-list ul > li').each(function () {
        var $item = $(this);
        var $categoryAnchor = $item.find('a').last();
        var categoryLink = $categoryAnchor.attr('href');
        if (!categoryLink || $item.find('a img').length) {
            return;
        }

        $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 10000,
            cache: true,
            url: categoryLink,
            success: function (e) {
                var doc = shoptet.common.createDocumentFromString(e);
                var ogImageUrl = $(doc).find('meta[property="og:image"]').attr('content');

                if (ogImageUrl && !$item.find('a img').length) {
                    $categoryAnchor.before('<a href="' + categoryLink + '"><img src="' + ogImageUrl + '"></a>');
                }
            }
        });
    });

    var productsCount = $("#products-found #products .product").length;
    $(".listingControls button.loadMore__button ").text('Zobrazit všechny produkty (' + productsCount + ')');
    $("#productsListHeading").text('Produkty (' + productsCount + ')');

    var blogCount = $("#search-group-articles ul li").length;
    $("#search-group-articles .display-results-group ").text('Zobrazit všechny články (' + blogCount + ')');

}